import { getUrl } from './connection'
import { alert } from './stores/alert'
import { loading } from './stores/loading'
import { authHeader } from './session'

import { translate } from './i18n'

import { getLocalStorage, LANG_STORAGE_NAME } from './storageUtils'

/**
 * Get all the models with his descriptions in the user lang
 * @returns {Promise<Object>}
 */
const getModelDicc = async (clientId) => {
  const lang = getLocalStorage(LANG_STORAGE_NAME) ?? 'es'
  const type = 'dictionaryAll'
  const [url, method] = await getUrl(type, { lang, clientId });
  
  loading.newLoading()
  try {
    const response = await fetch(url, {
      method,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        ...authHeader()
      },
    })
    if (response.status === 200) {
      const dicc = await response.json()
      return dicc.response
    }
    alert.newAlert({ message: translate((await response.json())['response']), type: 'error' })
  } catch (error) {
    alert.newAlert({ message: translate('errors.notLoadDicc'), type: 'error' })
    console.log('error')
  } finally {
    loading.removeLoading()
  }
}


export { getModelDicc }